import React from 'react';

/**
 * Obal stránky CRM komunikácia – štruktúra a triedy ako ServiceTaskList (intr003).
 * Samostatný modul (nekopíruje import z firemného portálu).
 */
export default function CrmCommunicationListPageShell({
  title,
  filterRow,
  toolbar,
  panelMenu,
  tableContainerRef,
  children,
}) {
  return (
    <div className="relative flex flex-col bg-gray-100 w-full h-[calc(100vh_-_137px)] py-4 px-4 overflow-y-auto">
      <div className="w-full px-4 py-4 bg-[#333] text-white border rounded-sm">
        <h2 className="text-left text-xl font-semibold whitespace-nowrap">{title}</h2>
      </div>
      <div className="flex flex-row flex-wrap items-start bg-white shadow-md p-4 gap-4">
        <div className="flex flex-row flex-wrap items-center gap-2">
          {filterRow}
        </div>
        {toolbar}
        {panelMenu}
      </div>
      <div ref={tableContainerRef}>
        {children}
      </div>
    </div>
  );
}
